import Body from '../../components/P2PBuySell/Body';

export default function P2PBuySellPage() {
	return (
		<div>
			<Body />
		</div>
	);
}
